import { Injectable } from "@angular/core";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import { Observable } from "rxjs";
import {
    ApplicationSession,
    ApplicationSessionResponseResultBundle,
    BulkUpdateRequestData,
    ListResponseData
} from "../../../core/types";

@Injectable({
    providedIn: "root"
})
export class ApplicationSessionsService {
    constructor(private api: RxApiService) {}

    public listSessions(
        appId: string,
        qs?: Object
    ): Observable<ListResponseData<ApplicationSession>> {
        return this.api.get(["apps", appId, "sessions"], qs);
    }

    public getSession(
        appId: string,
        sessionId: string
    ): Observable<ApplicationSessionResponseResultBundle> {
        return this.api.get(["apps", appId, "sessions", sessionId]);
    }

    public updateSession(
        appId: string,
        sessionId: string,
        sessionData: any
    ): Observable<ApplicationSessionResponseResultBundle> {
        return this.api.patch(["apps", appId, "sessions", sessionId], {}, sessionData);
    }

    public updateSessions(
        appId: string,
        bulkUpdateData: BulkUpdateRequestData<any>
    ): Observable<ApplicationSessionResponseResultBundle> {
        return this.api.patch(["apps", appId, "sessions", "_bulk"], {}, bulkUpdateData);
    }

    public deleteSession(
        appId: string,
        sessionId: string
    ): Observable<void> {
        return this.api.remove(["apps", appId, "sessions", sessionId]);
    }
}
